<template>
  <div class="letter_wrap notice-page">
    <div class="red_top_bg page-top">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div class="big_tit">
        {{ $t('notice.message') }}
      </div>
    </div>

    <div class="msg_box">
      <van-empty
        v-if="empty"
        :description="$t('orders.noOrders')"
      />
      <article
        v-for="item in noticeList"
        v-else
        :key="item.id"
        class="notice-card"
        @click="$router.push('/notice/' + item.id)"
      >
        <div class="notice-head">
          <div class="notice-title van-ellipsis">
            <span
              v-if="item.status == 0"
              class="unread-dot"
            >
              <van-icon
                name="warning-o"
                size="13"
              />
            </span>
            {{ item[title] }}
          </div>
          <time class="notice-time">
            {{ item.add_time }}
          </time>
        </div>
        <div
          class="notice-content van-multi-ellipsis--l2"
          v-html="item[content]"
        />
      </article>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Empty, Icon } from "vant";
import Fetch from "../../utils/fetch";

Vue.use(Empty).use(Icon);

export default {
	name: "Login",
	data() {
		return {
			title: "title" ,
			content: "content" ,
			empty: false,
			data: {
				list: [],
			},
		};
	},
	computed: {
		noticeList() {
			return this.data && this.data.list ? this.data.list : [];
		},
	},
	created() {
		this.$parent.footer("user", false);
	},
	mounted() {
		this.start();
	},
	methods: {
		start() {
			Fetch("/user/notice").then(r => {
				var list = r.data && r.data.list ? r.data.list : [];

				this.data = r.data;
				this.empty = list.length === 0;
			});
		},
	},
};
</script>

<style lang="less" scoped>
.notice-page {
	min-height: 100vh;
	background: #fff;
	color: #16223a;
	padding-bottom: 80px;
	box-sizing: border-box;
}

.page-top {
	height: 44px;
	background: #fff;
	color: #16223a;
	border-bottom: 1px solid rgba(240, 242, 245, 1);
	box-sizing: border-box;

	.back_left {
		opacity: 0.88;
	}

	.big_tit {
		color: #16223a;
	}
}

.msg_box {
	padding: 16px 16px 0;
}

.notice-card {
	margin-bottom: 14px;
	padding: 16px 18px;
	border-radius: 14px;
	border: 1px solid rgba(255, 93, 122, 0.16);
	background: #fff;
	box-shadow: 0 12px 22px rgba(22, 34, 58, 0.08);
	box-sizing: border-box;
}

.notice-head {
	display: flex;
	align-items: center;
	justify-content: space-between;
	min-width: 0;
}

.notice-title {
	min-width: 0;
	flex: 1;
	color: #ff5d7a;
	font-size: 14px;
	font-weight: 700;
	line-height: 22px;
}

.unread-dot {
	width: 18px;
	height: 18px;
	margin-right: 6px;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	border-radius: 50%;
	background: rgba(255, 74, 74, 0.14);
	color: #ff4a4a;
	vertical-align: -3px;
}

.notice-time {
	flex: 0 0 auto;
	max-width: 42%;
	margin-left: 12px;
	color: #6d7688;
	font-size: 12px;
	line-height: 18px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.notice-content {
	margin-top: 10px;
	color: #6d7688;
	font-size: 13px;
	line-height: 20px;
}

/deep/ .notice-content * {
	max-width: 100%;
}

/deep/ .van-empty {
	padding-top: 72px;
}

/deep/ .van-empty__description {
	color: #9aa1aa;
}

@media screen and (max-width: 374px) {
	.msg_box {
		padding-right: 12px;
		padding-left: 12px;
	}

	.notice-card {
		padding-right: 14px;
		padding-left: 14px;
	}
}
.notice-page {
	min-height: 100vh;
	padding-bottom: calc(84px + env(safe-area-inset-bottom));
	background: #201c1d;
	color: #f4ece7;
}

.page-top {
	background: #201c1d;
	color: #f3c99e;
	border-bottom-color: #302723;
}

.page-top .back_left {
	opacity: 1;
	filter: brightness(0) saturate(100%) invert(86%) sepia(18%) saturate(702%) hue-rotate(333deg) brightness(99%) contrast(92%);
}

.page-top .big_tit {
	color: #f3c99e;
}

.msg_box {
	padding: 12px 10px 0;
}

.notice-card {
	margin-bottom: 10px;
	padding: 14px;
	border-color: #75654f;
	border-radius: 9px;
	background: linear-gradient(110deg, #232323, #303030);
	box-shadow: 0 10px 22px rgba(0, 0, 0, 0.24);
}

.notice-title {
	color: #f3c99e;
}

.unread-dot {
	background: rgba(243, 201, 158, 0.15);
	color: #f3c99e;
}

.notice-time,
.notice-content {
	color: #bda895;
}

/deep/ .notice-content *,
/deep/ .notice-content {
	color: inherit !important;
	background: transparent !important;
}

/deep/ .van-empty__description {
	color: #b28d6c;
}

@media screen and (max-width: 374px) {
	.msg_box {
		padding-right: 8px;
		padding-left: 8px;
	}
}
</style>
